import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import Guide from '@/modules/guide/views/Guide.vue'
const baseRoute = OneNetworkConfig.baseRoutePath
const guideRouter = [
  {
    path: `${baseRoute}/support/guide`,
    name: 'support-guide',
    meta: {
      component: Guide
    },
    component: PrivateRouter,
  },
]
export default guideRouter
